<ul class="list-group">
  @for (prescriber of prescribers; track prescriber) {
    <li
      (click)="onPrescriberClick(prescriber)"
      class="list-group-item list-group-item-action justify-content-between align-items-center"
      >
      <div>
        <strong>{{ prescriber.provider | providerNameWithNpi }} </strong>
      </div>
      <div>
        {{ prescriber.provider.displaySpecialty }}
      </div>
    </li>
  }
</ul>
